import React from 'react';

import BaseErrorToast from './BaseErrorToast';

const BaseTvDisabled = ({ ...props }) => <BaseErrorToast {...props}>
    <>
        Вы&nbsp;отключили Базовый пакет каналов и&nbsp;дополнительные каналы отключились вместе с&nbsp;ним.
    </>
</BaseErrorToast>;

export default BaseTvDisabled;
